import { createFeatureSelector, createSelector } from '@ngrx/store';

import { adapter } from './reference-scheme.reducer';
import { ProductType } from '../../shared/models';
import { ReferenceSchemeModuleState } from '../models/reference-scheme.model';

const { selectAll } = adapter.getSelectors();

export const getReferenceSchemeModuleState =
  createFeatureSelector<ReferenceSchemeModuleState>('referenceSchemeModule');

export const getReferenceSchemesState = createSelector(
  getReferenceSchemeModuleState,
  (state) => state.referenceSchemes,
);

export const getReferenceSchemes = createSelector(getReferenceSchemesState, selectAll);

export const getSelectedCountry = createSelector(
  getReferenceSchemeModuleState,
  (state) => state.selectedCountry,
);

export const getActiveProducts = createSelector(getReferenceSchemeModuleState, (state) =>
  state.products?.filter((product) => product.isActive && product.type === ProductType.Feed),
);
export const getActiveAdditives = createSelector(getReferenceSchemeModuleState, (state) =>
  state.products?.filter((product) => product.isActive && product.type === ProductType.Additive),
);
